<app-header [title]="'Production Volumes'">
</app-header>

<div class="flex-row" #productionvolume>
  <div class="flex-row flex-align-start flex-auto flex-25" style="padding:0 10px 10px 10px">

    <kendo-buttongroup class="flex-row flex-align-start flex-auto flex-25" style="margin:auto;padding-top:30px"
      [selection]="'single'">
      <button type="button" kendoButton
        [togglable]="true"
        [selected]="true"
        (click)="chooseRisked()">
        RISKED
      </button>
      <button type="button" kendoButton
        [togglable]="true"
        (click)="chooseUnRisked()">
        UNRISKED
      </button>
    </kendo-buttongroup>
  </div>

  <div class="flex-row flex-align-start flex-auto flex-25" style="padding:0 10px 10px 10px">

    <div class="flex-100">
      <div class="dp-label">Total Oil (BPD)</div>
      <input type="number" class="k-textbox read-only-value" readonly value="{{totalOil}}" style="width:230px">
    </div>
    <div class="flex-100">
      <div class="dp-label">Total Water (BPD)</div>
      <input type="number" class="k-textbox read-only-value" readonly value="{{totalWater}}" style="width:230px">
    </div>
    <div class="flex-100">
      <div class="dp-label">Total Liquids (BPD)</div>
      <input type="number" class="k-textbox read-only-value" readonly value="{{totalLiquids}}" style="width:230px">
    </div>

  </div>
  <div class="flex-row flex-align-start flex-auto flex-25" style="padding:0 10px 10px 10px">

    <div class="flex-100">
      <div class="dp-label">Total Gas (MCPD)</div>
      <input type="number" class="k-textbox read-only-value" readonly value="{{totalGas}}" style="width:230px">
    </div>
    <div class="flex-100">
      <div class="dp-label">GOR SCF/BBL</div>
      <input type="number" class="k-textbox read-only-value" readonly value="{{gorScf}}" style="width:230px">
    </div>
  </div>

</div>